function getNameByID(ArrayToSearch, ID, Name) {
  const staffMember = ArrayToSearch.find((member) => member._id === ID);
  return staffMember ? staffMember[Name] : undefined;
}

module.exports = getNameByID;
